var render, staticRenderFns
import script from "./AccordionItemFunctional.vue?vue&type=script&lang=js&"
export * from "./AccordionItemFunctional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/eduardohdz/Documents/Trabajo/Repositorios/PlentyMarkets/Multicontent_latest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2826b4ce')) {
      api.createRecord('2826b4ce', component.options)
    } else {
      api.reload('2826b4ce', component.options)
    }
    
  }
}
component.options.__file = "resources/js/src/components/AccordionItemFunctional.vue"
export default component.exports